import axios from 'axios';
import { toast } from 'react-toastify';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

httpClient.interceptors.request.use(function (config) {
  const token = localStorage.getItem('exeltis-api-token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

httpClient.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.response) {
      if ([400, 500].includes(error.response.status)) {
        toast.error(
          'Algo deu errado ao carregar essa solicitação. Tente novamente.',
        );
      }

      if (error.response.status === 401) {
        localStorage.removeItem('exeltis-api-token');
        localStorage.removeItem('exeltis-user');
        window.location.href = '/login';
      }
    } else {
      toast.error(
        'Erro de conexão. Verifique sua internet ou tente novamente.',
      );
    }

    return Promise.reject(error);
  },
);

export default httpClient;
